/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Icd10Code } from './Icd10Code';
import type { SpecimenProtocolOverride } from './SpecimenProtocolOverride';

export type LISSpecimen = {
    readonly id?: number;
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    lis_state?: LISSpecimen.lis_state | null;
    /**
     * Final gross description
     */
    gross_description?: string | null;
    materials_received?: string | null;
    /**
     * Modifier selections for Grossing Mad-Lib
     */
    grossing_modifier_selections?: any;
    /**
     * Token selections for Grossing Mad-Lib
     */
    grossing_token_selections?: any;
    /**
     * Using text editing instead of Grossing Mad-Lib?
     */
    grossing_raw_text?: boolean;
    /**
     * LabStain selections for Grossing Mad-Lib. Should only be used for Specimen Protocols.
     */
    grossing_lab_stain_selections?: Array<number> | null;
    /**
     * LabPanel selections for Grossing Mad-Lib. Should only be used for Specimen Protocols.
     */
    grossing_lab_panel_selections?: Array<number> | null;
    source?: string | null;
    biopsy_type?: LISSpecimen.biopsy_type;
    procedure?: LISSpecimen.procedure | null;
    site?: string | null;
    /**
     * Changing clinical history may also change protocols
     */
    clinical_history?: string | null;
    readonly updated_at?: string;
    /**
     * Changing this value will ALSO modify the collected_date for the case.
     */
    collected_date?: string | null;
    /**
     * Changing this value will ALSO modify the received_date for the case.
     */
    received_date?: string | null;
    protocols?: Array<'dif' | 'alopecia' | 'whole_specimen' | 'nail' | 'pash_reflex' | 'pasf_reflex' | 'slow_mohs'>;
    readonly protocol_overrides?: Array<SpecimenProtocolOverride>;
    /**
     * what is the source for the specimen
     */
    type?: LISSpecimen.type | null;
    readonly slow_mohs_source_id?: number;
    readonly icd10codes?: Array<Icd10Code>;
}

export namespace LISSpecimen {

    export enum lis_state {
        BOTTLED = 'bottled',
        RECEIVED = 'received',
        GROSSED = 'grossed',
    }

    export enum biopsy_type {
        PUNCH = 'PUNCH',
        SHAVE = 'SHAVE',
        EXCISION = 'EXCISION',
        UNKNOWN = 'UNKNOWN',
    }

    export enum procedure {
        C = 'c',
        E = 'e',
        PE = 'pe',
        IB = 'ib',
        NC = 'nc',
        NA = 'na',
        PB = 'pb',
        SB = 'sb',
        SBD = 'sbd',
        SCE = 'sce',
        SR = 'sr',
        SRD = 'srd',
        SNB = 'snb',
        GR = 'gr',
        SE = 'se',
        EBX = 'ebx',
        FB = 'fb',
        MOHS = 'mohs',
        DBLK = 'dblk',
        U = 'u',
        O = 'o',
    }

    /**
     * what is the source for the specimen
     */
    export enum type {
        MUCOSA = 'MUCOSA',
        SKIN = 'SKIN',
        NAIL = 'NAIL',
        SOFT_TISSUE = 'SOFT TISSUE',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }


}
